import {
  RESET_SPECIFIC_TENANTS,
  RESET_TENANTS,
  SET_SPECIFIC_TENANTS,
  SET_TENANTS,
  SET_TENANT_ROLES,
  RESET_TENANT_ROLES,
} from "../Types/TenantTypes";

const initialState = {
  allTenants: [],
  specificTenant: null,
  tenantRoles: [],
};

const TenantReducer = (state = initialState, action) => {
  if (action.type === SET_TENANTS) {
    return { ...state, allTenants: action.payLoad };
  } else if (action.type === RESET_TENANTS) {
    return { ...state, allTenants: [] };
  } else if (action.type === SET_SPECIFIC_TENANTS) {
    return { ...state, specificTenant: action.payLoad };
  } else if (action.type === RESET_SPECIFIC_TENANTS) {
    return { ...state, specificTenant: null };
  } else if (action.type === SET_TENANT_ROLES) {
    return { ...state, tenantRoles: action.payLoad };
  } else if (action.type === RESET_TENANT_ROLES) {
    return { ...state, tenantRoles: [] };
  } else {
    return state;
  }
};

export default TenantReducer;
